import { calculatePriceOfItemByVoucher } from './calculatePriceOfItemByVoucher';
import { IVoucherGroup, IItem } from 'helpers/src/vouchers/interfaces/calculateVouchers';

export const calculatePriceOfItemByVouchers = (
  item: IItem,
  voucherGroups: Array<IVoucherGroup>,
  orderTotal: number,
  currencyId: string,
  customerGroupId: string | string[],
  orderItems: Array<any>,
) => {
  let lowestPrice = item.price;

  for (const group of voucherGroups) {
    const price = calculatePriceOfItemByVoucher(
      item,
      group,
      orderTotal,
      currencyId,
      customerGroupId,
      orderItems
    );

    if (price < lowestPrice) {
      lowestPrice = price;
    }
  }

  return lowestPrice;
};



// WEBPACK FOOTER //
// ../helpers/src/vouchers/calculatePriceOfItemByVouchers.ts